import * as login from './login'
import * as home from './home'  //登录后首页请求这一套（报纸）
import * as noLimitHome from './noLimitHome' //未登录后首页请求这一套（报纸）
import * as persion from './persion'
const api={
  login,
  home,
  noLimitHome,
  persion
}
export default api;